import React from 'react';
import './settings.scss';

import { connect } from 'react-redux';
import { fetchSubscription } from '../../store/actions/subscriptionActions';
import { LEFT, RIGHT, UP, DOWN, BACK, ENTER } from '../../util/remoteButtons';
import { fireAnalytics } from '../../pages/utils';
import { fetchDevice, updateDevice } from '../../store/actions/deviceActions';
import {
  setShowLogo,
  setShowArtworkDetails,
  set4kQuality,
  setMute,
  setSwitchArtwork,
  setQR,
  setMatchContent,
} from '../../store/actions/settingActions';

class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navBar: false,
      mute: false,
      errorPopup: false,
      open: false,
      showLogo: false,
      highResolution: false,
      switch: false,
      showDetails: false,
      qr: this.props.setting.qr,
      isActive: false,
      selectedInterval: 'minutes',
      matchContent: true,
    };
    this.selectedBtn = 'resolutionBase';
    this.selectedBtn1 = 'No';
    this.errorMessage = '';
    this.setting = React.createRef();
    this.intervalOptions = React.createRef();
    this.minutes = React.createRef();
    this.seconds = React.createRef();
    this.hours = React.createRef();
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentWillMount() {
    if (this.props.setting.mute) this.setState({ mute: true });
    if (this.props.setting.qr) this.setState({ qr: true });
    if (this.props.setting.showLogo) this.setState({ showLogo: true });
    if (this.props.setting.showArtworkDetails) this.setState({ showDetails: true });
    if (this.props.setting.switchArtwork) this.setState({ switch: true });
    if (this.props.setting.quality4k) this.setState({ highResolution: true });
    this.props.setting.matchContent ? this.setState({ matchContent: true }) : this.setState({ matchContent: false })
  }

  async componentDidMount() {
    setTimeout(() => {
      this.setting.current.focus();
    }, 300);
    fireAnalytics('Page', 'Settings Page Loaded');
    setTimeout(() => {
      if (this.props.setting.mute) {
        document.getElementById('muteOverlay').style.display = 'block';
        document.getElementById('muteBase').style.display = 'none';
        document.getElementById('muteSwitch').style.left = 'auto';
        document.getElementById('muteSwitch').style.right = 0;
        this.setState({
          mute: true,
        });
      }
      if (this.props.setting.showLogo) {
        document.getElementById('logoOverlay').style.display = 'block';
        document.getElementById('logoBase').style.display = 'none';
        document.getElementById('logoSwitch').style.left = 'auto';
        document.getElementById('logoSwitch').style.right = 0;
        this.setState({ showLogo: true });
      }
      if (this.props.setting.showArtworkDetails) {
        document.getElementById('detailsOverlay').style.display = 'block';
        document.getElementById('detailsBase').style.display = 'none';
        document.getElementById('detailsSwitch').style.left = 'auto';
        document.getElementById('detailsSwitch').style.right = 0;
        this.setState({ showDetails: true });
      }
      if (this.props.setting.qr) {
        document.getElementById('qrOverlay').style.display = 'block';
        document.getElementById('qrBase').style.display = 'none';
        document.getElementById('qrSwitch').style.left = 'auto';
        document.getElementById('qrSwitch').style.right = 0;
        this.setState({ qr: true });
      }
      if (this.props.setting.switchArtwork) {
        document.getElementById('switchOverlay').style.display = 'block';
        document.getElementById('switchBase').style.display = 'none';
        document.getElementById('switchSwitch').style.left = 'auto';
        document.getElementById('switchSwitch').style.right = 0;
        this.setState({ switch: true });
      }
      if (this.props.setting.quality4k) {
        document.getElementById('resolutionOverlay').style.display = 'block';
        document.getElementById('resolutionBase').style.display = 'none';
        document.getElementById('resolutionSwitch').style.left = 'auto';
        document.getElementById('resolutionSwitch').style.right = 0;
        this.selectedBtn = 'resolutionOverlay';
        this.setState({ highResolution: true });
      }
      if (this.props.setting.matchContent) {
        document.getElementById('contentSwitch').style.left = 'auto';
        document.getElementById('contentSwitch').style.right = 0;
      }
      if (this.props.device.data.interval <= 60000) {
        document.getElementById('intervalTime').value = Math.floor(this.props.device.data.interval / 1000);
        this.setState({
          selectedInterval: 'seconds'
        })
      } else if (this.props.device.data.interval <= 3600000) {
        document.getElementById('intervalTime').value = Math.floor(this.props.device.data.interval / 60000);
        this.setState({
          selectedInterval: 'minutes'
        })
      } else {
        document.getElementById('intervalTime').value = Math.floor(this.props.device.data.interval / 3600000);
        this.setState({
          selectedInterval: 'hours'
        })
      }
    }, 200);
  }

  async handleKeyDown(e) {
    e.stopPropagation();
    e.preventDefault();
    switch (e.keyCode) {
      case UP:
        if (this.selectedBtn === 'MuteBase' || this.selectedBtn === 'MuteOverlay') {
          document.getElementById('resolution').classList.add('settingsActiveElement');
          document.getElementById('muteDevice').classList.remove('settingsActiveElement');
          if (this.state.highResolution) {
            this.selectedBtn = 'resolutionOverlay';
          } else {
            this.selectedBtn = 'resolutionBase';
          }
        } else if (this.selectedBtn === 'LogoBase' || this.selectedBtn === 'LogoOverlay') {
          document.getElementById('muteDevice').classList.add('settingsActiveElement');
          document.getElementById('showLogo').classList.remove('settingsActiveElement');
          if (this.state.mute) {
            this.selectedBtn = 'MuteOverlay';
          } else {
            this.selectedBtn = 'MuteBase';
          }
        } else if (this.selectedBtn === 'detailsBase' || this.selectedBtn === 'detailsOverlay') {
          document.getElementById('showLogo').classList.add('settingsActiveElement');
          document.getElementById('showDetails').classList.remove('settingsActiveElement');
          if (this.state.showLogo) {
            this.selectedBtn = 'LogoOverlay';
          } else {
            this.selectedBtn = 'LogoBase';
          }
        } else if (this.selectedBtn === 'qrBase' || this.selectedBtn === 'qrOverlay') {
          document.getElementById('showDetails').classList.add('settingsActiveElement');
          document.getElementById('qr').classList.remove('settingsActiveElement');
          if (this.state.showDetails) {
            this.selectedBtn = 'detailsOverlay';
          } else {
            this.selectedBtn = 'detailsBase';
          }
        } else if (this.selectedBtn === 'contentBase' || this.selectedBtn === 'contentOverlay') {
          document.getElementById('qr').classList.add('settingsActiveElement');
          document.getElementById('content').classList.remove('settingsActiveElement');
          if (this.state.qr) {
            this.selectedBtn = 'qrOverlay';
          } else {
            this.selectedBtn = 'qrBase';
          }
        } else if (this.selectedBtn === 'switchBase' || this.selectedBtn === 'switchOverlay') {
          document.getElementById('content').classList.add('settingsActiveElement');
          document.getElementById('switch').classList.remove('settingsActiveElement');
          if (this.state.matchContent) {
            this.selectedBtn = 'contentOverlay';
          } else {
            this.selectedBtn = 'contentBase';
          }
        } else if (this.selectedBtn === 'IntervalTime') {
          var val = parseInt(document.getElementById('intervalTime').value);
          if (val < 59) {
            val++;
            document.getElementById('intervalTime').value = val;
          } else {
            this.errorMessage = 'Value Cannot Exceed 59';
            this.setState({ errorPopup: true });
            setTimeout(() => {
              this.setState({ errorPopup: false });
            }, 3000);
          }
        } else if (this.selectedBtn === 'IntervalOptions') {
          this.intervalOptions.current.blur();
          this.setting.current.focus();
          document.getElementById('switch').classList.add('settingsActiveElement');
          document.getElementById('intervalOptions').classList.remove('settingsActiveElement');
          if (this.state.switch) {
            this.selectedBtn = 'switchBase';
          } else {
            this.selectedBtn = 'switchOverlay';
          }
        } else if (this.selectedBtn === 'Back') {
          this.setting.current.blur();
          this.intervalOptions.current.focus();
          document.getElementById('intervalOptions').classList.add('settingsActiveElement');
          document.getElementById('backBtn').classList.remove('settingsActiveElement');
          this.selectedBtn = 'IntervalOptions';
        } else if (this.selectedBtn === 'minutes') {
          document.getElementById('minutes').focus()
          document.getElementById('minutes').classList.remove('settingsActiveElement');
          document.getElementById('seconds').classList.add('settingsActiveElement');
          this.selectedBtn = 'seconds'
        } else if (this.selectedBtn === 'hours') {
          document.getElementById('minutes').focus()
          document.getElementById('hours').classList.remove('settingsActiveElement');
          document.getElementById('minutes').classList.add('settingsActiveElement');
          this.selectedBtn = 'minutes'
        }
        break;
      case 27:
      case BACK:
        if (this.state.open) {
          this.setState({ open: false });
        } else {
          let selectedOption = this.state.selectedInterval;
          let interval;
          if (selectedOption === 'seconds') {
            interval = parseInt(document.getElementById('intervalTime').value) * 1000;
          } else if (selectedOption === 'minutes') {
            interval = parseInt(document.getElementById('intervalTime').value) * 60000;
          } else if (selectedOption === 'hours') {
            interval = parseInt(document.getElementById('intervalTime').value) * 3600000;
          }
          if (interval !== this.props.device.data.interval) {
            const response = await this.props.updateDevice(this.props.device.data.id, 'interval', interval);
            if (response.success) {
              this.errorMessage = 'Settings Updated Successfully';
              this.setState({ errorPopup: true });
              const fetch = await this.props.fetchDevice(this.props.app.SCAPDeviceId);
              setTimeout(() => {
                this.setState({ errorPopup: false });
                this.props.onClose();
              }, 3000);
            } else {
              this.errorMessage = 'Unable to Save Settings';
              this.setState({ errorPopup: true });
              await this.props.fetchDevice(this.props.app.SCAPDeviceId);
              setTimeout(() => {
                this.setState({ errorPopup: false });
                this.props.onClose();
              }, 3000);
            }
          } else {
            this.errorMessage = 'Settings updated successfully';
            this.setState({ errorPopup: true });
            setTimeout(() => {
              this.setState({ errorPopup: false });
              this.props.onClose();
            }, 3000);
          }
        }
        break;
      case ENTER:
        if (this.state.open) {
          if (this.selectedBtn1 === 'No') {
            this.setState({ open: false });
            return;
          }
          if (this.selectedBtn1 === 'Yes') {
            tizen.application.getCurrentApplication().exit();
          }
        } else {
          if (this.selectedBtn === 'MuteBase') {
            const response = await this.props.updateDevice(this.props.device.data.id, 'mute', !this.state.mute);
            if (response.success) {
              this.props.updateMute(!this.state.mute);
              this.setState({
                mute: !this.state.mute,
              });
              document.getElementById('muteOverlay').style.display = 'block';
              document.getElementById('muteBase').style.display = 'none';
              document.getElementById('muteSwitch').style.left = 'auto';
              document.getElementById('muteSwitch').style.right = 0;
              this.selectedBtn = 'MuteOverlay';
              await this.props.fetchDevice(this.props.app.SCAPDeviceId);
            }
          } else if (this.selectedBtn === 'MuteOverlay') {
            const response = await this.props.updateDevice(this.props.device.data.id, 'mute', !this.state.mute);
            if (response.success) {
              this.props.updateMute(!this.state.mute);
              this.setState({
                mute: !this.state.mute,
              });
              document.getElementById('muteBase').style.display = 'block';
              document.getElementById('muteOverlay').style.display = 'none';
              document.getElementById('muteSwitch').style.left = 0;
              document.getElementById('muteSwitch').style.right = 'auto';
              this.selectedBtn = 'MuteBase';
              await this.props.fetchDevice(this.props.app.SCAPDeviceId);
            }
          } else if (this.selectedBtn === 'LogoBase') {
            const response = await this.props.updateDevice(this.props.device.data.id, 'logo', !this.state.logo);
            if (response.success) {
              this.setState({
                logo: !this.state.logo,
              });
              document.getElementById('logoOverlay').style.display = 'block';
              document.getElementById('logoBase').style.display = 'none';
              document.getElementById('logoSwitch').style.left = 'auto';
              document.getElementById('logoSwitch').style.right = 0;
              this.selectedBtn = 'LogoOverlay';
              this.props.updateShowLogo(true);
              await this.props.fetchDevice(this.props.app.SCAPDeviceId);
            }
          } else if (this.selectedBtn === 'LogoOverlay') {
            const response = await this.props.updateDevice(this.props.device.data.id, 'logo', !this.state.logo);
            if (response.success) {
              this.setState({
                logo: !this.state.logo,
              });
              document.getElementById('logoBase').style.display = 'block';
              document.getElementById('logoOverlay').style.display = 'none';
              document.getElementById('logoSwitch').style.left = 0;
              document.getElementById('logoSwitch').style.right = 'auto';
              this.selectedBtn = 'LogoBase';
              this.props.updateShowLogo(false);
              await this.props.fetchDevice(this.props.app.SCAPDeviceId);
            }
          } else if (this.selectedBtn === 'contentBase') {
            const response = await this.props.updateDevice(this.props.device.data.id, 'content', !this.state.matchContent);
            if (response.success) {
              this.setState({
                matchContent: !this.state.matchContent,
              });
              // document.getElementById('logoOverlay').style.display = 'block';
              // document.getElementById('logoBase').style.display = 'none';
              document.getElementById('contentSwitch').style.left = 'auto';
              document.getElementById('contentSwitch').style.right = 0;
              this.selectedBtn = 'contentOverlay';
              this.props.updateMatchContent(true);
              await this.props.fetchDevice(this.props.app.SCAPDeviceId);
            }
          } else if (this.selectedBtn === 'contentOverlay') {
            const response = await this.props.updateDevice(this.props.device.data.id, 'content', !this.state.matchContent);
            if (response.success) {
              this.setState({
                matchContent: !this.state.matchContent,
              });
              // document.getElementById('logoBase').style.display = 'block';
              // document.getElementById('logoOverlay').style.display = 'none';
              document.getElementById('contentSwitch').style.left = 0;
              document.getElementById('contentSwitch').style.right = 'auto';
              this.selectedBtn = 'contentBase';
              this.props.updateMatchContent(false);
              await this.props.fetchDevice(this.props.app.SCAPDeviceId);
            }
          } else if (this.selectedBtn === 'qrBase') {
            const response = await this.props.updateDevice(this.props.device.data.id, 'qr', !this.state.qr);
            if (response.success) {
              this.setState({
                qr: !this.state.qr,
              });
              document.getElementById('qrOverlay').style.display = 'block';
              document.getElementById('qrBase').style.display = 'none';
              document.getElementById('qrSwitch').style.left = 'auto';
              document.getElementById('qrSwitch').style.right = 0;
              this.props.updateQR(true);
              this.selectedBtn = 'qrOverlay';
              await this.props.fetchDevice(this.props.app.SCAPDeviceId);
            }
          } else if (this.selectedBtn === 'qrOverlay') {
            const response = await this.props.updateDevice(this.props.device.data.id, 'qr', !this.state.qr);
            if (response.success) {
              this.setState({
                qr: !this.state.qr,
              });
              document.getElementById('qrBase').style.display = 'block';
              document.getElementById('qrOverlay').style.display = 'none';
              document.getElementById('qrSwitch').style.left = 0;
              document.getElementById('qrSwitch').style.right = 'auto';
              this.props.updateQR(false);
              this.selectedBtn = 'qrBase';
              await this.props.fetchDevice(this.props.app.SCAPDeviceId);
            }
          } else if (this.selectedBtn === 'switchBase') {
            document.getElementById('switchOverlay').style.display = 'block';
            document.getElementById('switchBase').style.display = 'none';
            document.getElementById('switchSwitch').style.left = 'auto';
            document.getElementById('switchSwitch').style.right = 0;
            this.selectedBtn = 'switchOverlay';
            this.props.updateSwitchArtwork(true);
          } else if (this.selectedBtn === 'switchOverlay') {
            document.getElementById('switchBase').style.display = 'block';
            document.getElementById('switchOverlay').style.display = 'none';
            document.getElementById('switchSwitch').style.left = 0;
            document.getElementById('switchSwitch').style.right = 'auto';
            this.selectedBtn = 'switchBase';
            this.props.updateSwitchArtwork(false);
          } else if (this.selectedBtn === 'detailsBase') {
            const response = await this.props.updateDevice(this.props.device.data.id, 'details', !this.state.showDetails);
            if (response.success) {
              document.getElementById('detailsOverlay').style.display = 'block';
              document.getElementById('detailsBase').style.display = 'none';
              document.getElementById('detailsSwitch').style.left = 'auto';
              document.getElementById('detailsSwitch').style.right = 0;
              this.selectedBtn = 'detailsOverlay';
              this.props.updateShowArtDetails(true);
              await this.props.fetchDevice(this.props.app.SCAPDeviceId);
            }
          } else if (this.selectedBtn === 'detailsOverlay') {
            const response = await this.props.updateDevice(this.props.device.data.id, 'details', !this.state.showDetails);
            if (response.success) {
              document.getElementById('detailsBase').style.display = 'block';
              document.getElementById('detailsOverlay').style.display = 'none';
              document.getElementById('detailsSwitch').style.left = 0;
              document.getElementById('detailsSwitch').style.right = 'auto';
              this.selectedBtn = 'detailsBase';
              this.props.updateShowArtDetails(false);
              await this.props.fetchDevice(this.props.app.SCAPDeviceId);
            }
          } else if (this.selectedBtn === 'resolutionBase') {
            const response = await this.props.updateDevice(
              this.props.device.data.id,
              'highQuality',
              !this.state.highResolution
            );
            if (response.success) {
              this.setState({
                highResolution: !this.state.highResolution,
              });
              document.getElementById('resolutionOverlay').style.display = 'block';
              document.getElementById('resolutionBase').style.display = 'none';
              document.getElementById('resolutionSwitch').style.left = 'auto';
              document.getElementById('resolutionSwitch').style.right = 0;
              this.selectedBtn = 'resolutionOverlay';
              this.props.updateQuality(true);
              await this.props.fetchDevice(this.props.app.SCAPDeviceId);
            }
          } else if (this.selectedBtn === 'resolutionOverlay') {
            const response = await this.props.updateDevice(
              this.props.device.data.id,
              'highQuality',
              !this.state.highResolution
            );
            if (response.success) {
              this.setState({
                highResolution: !this.state.highResolution,
              });
              document.getElementById('resolutionBase').style.display = 'block';
              document.getElementById('resolutionOverlay').style.display = 'none';
              document.getElementById('resolutionSwitch').style.left = 0;
              document.getElementById('resolutionSwitch').style.right = 'auto';
              this.selectedBtn = 'resolutionBase';
              this.props.updateQuality(false);
              await this.props.fetchDevice(this.props.app.SCAPDeviceId);
            }
          } else if (this.selectedBtn === 'Back') {
            let selectedOption = this.state.selectedInterval;
            let interval;
            if (selectedOption === 'seconds') {
              interval = parseInt(document.getElementById('intervalTime').value) * 1000;
            } else if (selectedOption === 'minutes') {
              interval = parseInt(document.getElementById('intervalTime').value) * 60000;
            } else if (selectedOption === 'hours') {
              interval = parseInt(document.getElementById('intervalTime').value) * 3600000;
            }
            if (interval !== this.props.device.data.interval) {
              const response = await this.props.updateDevice(this.props.device.data.id, 'interval', interval);
              if (response.success) {
                this.errorMessage = 'Settings Updated Successfully';
                this.setState({ errorPopup: true });
                const fetch = await this.props.fetchDevice(this.props.app.SCAPDeviceId);
                setTimeout(() => {
                  this.setState({ errorPopup: false });
                  this.props.onClose();
                }, 3000);
              } else {
                this.errorMessage = 'Unable to Save Settings';
                this.setState({ errorPopup: true });
                await this.props.fetchDevice(this.props.app.SCAPDeviceId);
                setTimeout(() => {
                  this.setState({ errorPopup: false });
                  this.props.onClose();
                }, 3000);
              }
            } else {
              this.errorMessage = 'Settings updated successfully';
              this.setState({ errorPopup: true });
              setTimeout(() => {
                this.setState({ errorPopup: false });
                this.props.onClose();
              }, 3000);
            }
          } else if (this.selectedBtn === 'IntervalOptions') {
            this.setState({
              isActive: true
            }, () => {
              document.getElementById('seconds').focus()
              document.getElementById('intervalOptions').classList.remove('settingsActiveElement');
              document.getElementById('seconds').classList.add('settingsActiveElement');
              this.selectedBtn = 'seconds'
            })
          } else if (this.selectedBtn === 'seconds') {
            document.getElementById(this.selectedBtn).blur()
            document.getElementById('intervalOptions').classList.add('settingsActiveElement');
            document.getElementById(this.selectedBtn).classList.remove('settingsActiveElement');
            document.getElementById('intervalOptions').focus()
            this.selectedBtn = 'IntervalOptions';
            this.setState({
              selectedInterval: 'seconds',
              isActive: false
            })
          } else if (this.selectedBtn === 'minutes') {
            document.getElementById(this.selectedBtn).blur()
            document.getElementById('intervalOptions').classList.add('settingsActiveElement');
            document.getElementById(this.selectedBtn).classList.remove('settingsActiveElement');
            document.getElementById('intervalOptions').focus()
            this.selectedBtn = 'IntervalOptions';
            this.setState({
              selectedInterval: 'minutes',
              isActive: false
            })
          } else if (this.selectedBtn === 'hours') {
            document.getElementById(this.selectedBtn).blur()
            document.getElementById('intervalOptions').classList.add('settingsActiveElement');
            document.getElementById(this.selectedBtn).classList.remove('settingsActiveElement');
            document.getElementById('intervalOptions').focus()
            this.selectedBtn = 'IntervalOptions';
            this.setState({
              selectedInterval: 'hours',
              isActive: false
            })
          }
        }
        break;
      case DOWN:
        if (this.selectedBtn === 'resolutionBase' || this.selectedBtn === 'resolutionOverlay') {
          document.getElementById('muteDevice').classList.add('settingsActiveElement');
          document.getElementById('resolution').classList.remove('settingsActiveElement');
          if (!this.state.mute) this.selectedBtn = 'MuteBase';
          else this.selectedBtn = 'MuteOverlay';
        } else if (this.selectedBtn === 'MuteBase' || this.selectedBtn === 'MuteOverlay') {
          document.getElementById('showLogo').classList.add('settingsActiveElement');
          document.getElementById('muteDevice').classList.remove('settingsActiveElement');
          if (!this.state.showLogo) this.selectedBtn = 'LogoBase';
          else this.selectedBtn = 'LogoOverlay';
        } else if (this.selectedBtn === 'LogoBase' || this.selectedBtn === 'LogoOverlay') {
          document.getElementById('showDetails').classList.add('settingsActiveElement');
          document.getElementById('showLogo').classList.remove('settingsActiveElement');
          if (!this.state.showDetails) this.selectedBtn = 'detailsBase';
          else this.selectedBtn = 'detailsOverlay';
        } else if (this.selectedBtn === 'detailsBase' || this.selectedBtn === 'detailsOverlay') {
          document.getElementById('qr').classList.add('settingsActiveElement');
          document.getElementById('showDetails').classList.remove('settingsActiveElement');
          if (!this.state.qr) this.selectedBtn = 'qrBase';
          else this.selectedBtn = 'qrOverlay';
        } else if (this.selectedBtn === 'qrBase' || this.selectedBtn === 'qrOverlay') {
          document.getElementById('content').classList.add('settingsActiveElement');
          document.getElementById('qr').classList.remove('settingsActiveElement');
          if (!this.state.matchContent) this.selectedBtn = 'contentBase';
          else this.selectedBtn = 'contentOverlay';
        } else if (this.selectedBtn === 'contentBase' || this.selectedBtn === 'contentOverlay') {
          document.getElementById('switch').classList.add('settingsActiveElement');
          document.getElementById('content').classList.remove('settingsActiveElement');
          if (!this.state.switch) this.selectedBtn = 'switchBase';
          else this.selectedBtn = 'switchOverlay';
        } else if (this.selectedBtn === 'switchBase' || this.selectedBtn === 'switchOverlay') {
          document.getElementById('intervalOptions').focus();
          this.setting.current.blur();
          document.getElementById('intervalOptions').classList.add('settingsActiveElement');
          document.getElementById('switch').classList.remove('settingsActiveElement');
          this.selectedBtn = 'IntervalOptions';
        } else if (this.selectedBtn === 'IntervalTime') {
          var val = parseInt(document.getElementById('intervalTime').value);
          if (val > 0) {
            val--;
            document.getElementById('intervalTime').value = val;
          } else {
            this.errorMessage = 'Value Cannot be Less Than 0';
            this.setState({ errorPopup: true });
            setTimeout(() => {
              this.setState({ errorPopup: false });
            }, 3000);
          }
        } else if (this.selectedBtn === 'IntervalOptions') {
          document.getElementById('intervalOptions').blur();
          this.setting.current.focus();
          document.getElementById('backBtn').classList.add('settingsActiveElement');
          document.getElementById('intervalOptions').classList.remove('settingsActiveElement');
          this.selectedBtn = 'Back';
        } else if (this.selectedBtn === 'seconds') {
          document.getElementById('minutes').focus()
          document.getElementById('seconds').classList.remove('settingsActiveElement');
          document.getElementById('minutes').classList.add('settingsActiveElement');
          this.selectedBtn = 'minutes'
        } else if (this.selectedBtn === 'minutes') {
          document.getElementById('hours').focus()
          document.getElementById('minutes').classList.remove('settingsActiveElement');
          document.getElementById('hours').classList.add('settingsActiveElement');
          this.selectedBtn = 'hours'
        }
        break;
      case RIGHT:
        e.preventDefault();
        if (this.state.open) {
          document.getElementById('No').style.background = '';
          document.getElementById('yes').style.background = '#910048';
          this.refs.yes.focus();
          this.selectedBtn1 = 'Yes';
        } else {
          if (this.selectedBtn === 'IntervalTime') {
            document.getElementById('intervalOptions').focus();
            this.setting.current.blur();
            document.getElementById('intervalOptions').classList.add('settingsActiveElement');
            document.getElementById('intervalTime').classList.remove('settingsActiveElement');
            this.selectedBtn = 'IntervalOptions';

          }
        }
        break;
      case LEFT:
        e.preventDefault();
        if (this.state.open) {
          document.getElementById('yes').style.background = '';
          document.getElementById('No').style.background = '#910048';
          this.refs.no.focus();
          this.selectedBtn1 = 'No';
        } else {
          if (this.selectedBtn === 'seconds' || this.selectedBtn === 'minutes' || this.selectedBtn === 'hours') {
            this.setting.current.focus();
            document.getElementById(this.selectedBtn).blur()
            document.getElementById('intervalTime').classList.add('settingsActiveElement');
            document.getElementById(this.selectedBtn).classList.remove('settingsActiveElement');
            this.selectedBtn = 'IntervalTime';
            this.setState({
              isActive: false
            })
          } else if (this.selectedBtn === 'IntervalOptions') {
            this.setting.current.focus();
            document.getElementById('intervalOptions').blur()
            document.getElementById('intervalTime').classList.add('settingsActiveElement');
            document.getElementById('intervalOptions').classList.remove('settingsActiveElement');
            this.selectedBtn = 'IntervalTime';
            this.setState({
              isActive: false
            })
          }
        }
        break;
      case EXIT:
        if (this.state.open) {
          this.setState({ open: false });
        } else {
          this.setState({ open: !this.state.open });
          this.selectedBtn1 = 'No';
        }
        break;
      default:
        // console.log('Key Not Handled');
        break;
    }
  }

  render() {
    return (
      <div
        className="settings"
        style={{
          height: window.innerWidth <= window.innerHeight ? '56%' : '88%',
        }}
        ref={this.setting}
        onKeyDown={this.handleKeyDown}
        tabIndex={10}
      >
        <h3 className="account__header">Settings</h3>

        <div className="leftWrapper">
          <div className="leftWrapper_resolution-Wrapper">
            <div className="leftWrapper_resolution-Wrapper_text">4K Resolution</div>
            <div id="resolution" className="leftWrapper_resolution-Wrapper_images settingsActiveElement">
              <img
                id="resolutionBase"
                className="leftWrapper_resolution-Wrapper_images_base"
                src="/assets/img/base.png"
                alt=""
              />
              <img
                id="resolutionOverlay"
                className="leftWrapper_resolution-Wrapper_images_overlay"
                src="/assets/img/overlay.png"
                alt=""
              />
              <img
                id="resolutionSwitch"
                className="leftWrapper_resolution-Wrapper_images_switch"
                src="/assets/img/switch.png"
                alt=""
              />
            </div>
          </div>

          <div className="leftWrapper_muteDevice-Wrapper">
            <div className="leftWrapper_muteDevice-Wrapper_text">Mute Device</div>
            <div id="muteDevice" className="leftWrapper_muteDevice-Wrapper_images ">
              <img
                id="muteBase"
                className="leftWrapper_muteDevice-Wrapper_images_base"
                src="/assets/img/base.png"
                alt=""
              />
              <img
                id="muteOverlay"
                className="leftWrapper_muteDevice-Wrapper_images_overlay"
                src="/assets/img/overlay.png"
                alt=""
              />
              <img
                id="muteSwitch"
                className="leftWrapper_muteDevice-Wrapper_images_switch"
                src="/assets/img/switch.png"
                alt=""
              />
            </div>
          </div>

          <div className="leftWrapper_showLogo-Wrapper">
            <div className="leftWrapper_showLogo-Wrapper_text">Show Logo</div>
            <div id="showLogo" className="leftWrapper_showLogo-Wrapper_images">
              <img
                id="logoBase"
                className="leftWrapper_showLogo-Wrapper_images_base"
                src="/assets/img/base.png"
                alt=""
              />
              <img
                id="logoOverlay"
                className="leftWrapper_showLogo-Wrapper_images_overlay"
                src="/assets/img/overlay.png"
                alt=""
              />
              <img
                id="logoSwitch"
                className="leftWrapper_showLogo-Wrapper_images_switch"
                src="/assets/img/switch.png"
                alt=""
              />
            </div>
          </div>

          <div className="leftWrapper_showDetails-Wrapper">
            <div className="leftWrapper_showDetails-Wrapper_text">Always Show Artwork Details</div>
            <div id="showDetails" className="leftWrapper_showDetails-Wrapper_images">
              <img
                id="detailsBase"
                className="leftWrapper_showDetails-Wrapper_images_base"
                src="/assets/img/base.png"
                alt=""
              />
              <img
                id="detailsOverlay"
                className="leftWrapper_showDetails-Wrapper_images_overlay"
                src="/assets/img/overlay.png"
                alt=""
              />
              <img
                id="detailsSwitch"
                className="leftWrapper_showDetails-Wrapper_images_switch"
                src="/assets/img/switch.png"
                alt=""
              />
            </div>
          </div>
          <div className="leftWrapper_qr-Wrapper">
            <div className="leftWrapper_qr-Wrapper_text">Show QR</div>
            <div id="qr" className="leftWrapper_qr-Wrapper_images">
              <img
                id="qrBase"
                className="leftWrapper_qr-Wrapper_images_base"
                src="/assets/img/base.png"
                alt=""
              />
              <img
                id="qrOverlay"
                className="leftWrapper_qr-Wrapper_images_overlay"
                src="/assets/img/overlay.png"
                alt=""
              />
              <img
                id="qrSwitch"
                className="leftWrapper_qr-Wrapper_images_switch"
                src="/assets/img/switch.png"
                alt=""
              />
            </div>
          </div>

          <div className="leftWrapper_content-Wrapper">
            <div className="leftWrapper_content-Wrapper_text">Match Content</div>
            <div id="content" className="leftWrapper_content-Wrapper_images">
              {this.state.matchContent ? <img
                id="contentOverlay"
                className="leftWrapper_content-Wrapper_images_overlay"
                src="/assets/img/overlay.png"
                alt=""
              /> : <img
                id="contentBase"
                className="leftWrapper_content-Wrapper_images_base"
                src="/assets/img/base.png"
                alt=""
              />
              }
              <img
                id="contentSwitch"
                className="leftWrapper_content-Wrapper_images_switch"
                src="/assets/img/switch.png"
                alt=""
              />
            </div>
          </div>

          <div className="leftWrapper_switch-Wrapper">
            <div className="leftWrapper_switch-Wrapper_text">Switch Artwork</div>
            <div id="switch" className="leftWrapper_switch-Wrapper_images">
              <img
                id="switchBase"
                className="leftWrapper_switch-Wrapper_images_base"
                src="/assets/img/base.png"
                alt=""
              />
              <img
                id="switchOverlay"
                className="leftWrapper_switch-Wrapper_images_overlay"
                src="/assets/img/overlay.png"
                alt=""
              />
              <img
                id="switchSwitch"
                className="leftWrapper_switch-Wrapper_images_switch"
                src="/assets/img/switch.png"
                alt=""
              />
            </div>
          </div>

          <div className="leftWrapper_switchArtwork-Wrapper">
            <div className="leftWrapper_switchArtwork-Wrapper_text">Switch Artwork Every</div>
            <div className="leftWrapper_switchArtwork-Wrapper_images">
              <input type="text" id="intervalTime" name="intervalTime" />

              <div>
                <button
                  name="intervalOptions" id="intervalOptions" ref={this.intervalOptions}
                >
                  {this.state.selectedInterval}
                </button>
                {this.state.isActive && (
                  <nav
                    style={{ position: 'absolute', display: 'flex', flexDirection: "column", top: '2rem', background: '#222' }}
                  >
                    <button
                      ref={this.seconds}
                      id="seconds"
                      name="seconds"
                      className='menuItem'
                    >
                      Seconds
                    </button>
                    <button
                      ref={this.minutes}
                      id="minutes"
                      className='menuItem'
                    >
                      Minutes
                    </button>
                    <button
                      ref={this.hours}
                      id="hours"
                      className='menuItem'
                    >
                      Hours
                    </button>

                  </nav>
                )}
              </div>
            </div>
          </div>
          <div className="leftWrapper_backBtn-Wrapper">
            <div
              className="leftWrapper_backBtn-Wrapper_text"
              style={{
                padding: window.innerWidth <= window.innerHeight ? '3%' : '1%',
              }}
              id="backBtn"
            >
              Back
            </div>
          </div>
        </div>

        <div
          className="account__footer"
          style={{
            height: window.innerWidth <= window.innerHeight ? '120px' : '95px',
            fontSize: window.innerWidth <= window.innerHeight ? '1.8rem' : '1.5rem',
          }}
        >
          For help contact: <strong>support@blackdove.com</strong>
        </div>

        <div className="timedPopup" style={!this.state.errorPopup ? { opacity: '0' } : { opacity: '1' }}>
          {this.errorMessage}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateDevice: (deviceId, updateVal, value) => dispatch(updateDevice(deviceId, updateVal, value)),
  fetchDevice: (deviceId) => dispatch(fetchDevice(deviceId)),
  fetchSubscription: () => dispatch(fetchSubscription()),
  updateMute: (val) => dispatch(setMute(val)),
  updateShowLogo: (val) => dispatch(setShowLogo(val)),
  updateShowArtDetails: (val) => dispatch(setShowArtworkDetails(val)),
  updateQR: (val) => dispatch(setQR(val)),
  updateSwitchArtwork: (val) => dispatch(setSwitchArtwork(val)),
  updateQuality: (val) => dispatch(set4kQuality(val)),
  updateMatchContent: (val) => dispatch(setMatchContent(val)),
});
export default connect((state) => {
  const { app, subscription, device, setting } = state;
  return {
    app,
    subscription,
    device,
    setting,
  };
}, mapDispatchToProps)(Settings);
